import { useBreakpoint } from '../hooks/useBreakpoint.js';
import { useHasMounted } from '../hooks/useHasMounted.js';
import { jsx, Fragment } from 'react/jsx-runtime';
const breakpointMap = {
  phone: 'isPhone',
  tablet: 'isTablet',
  desktop: 'isDesktop'
};
function Only({
  on,
  children
}) {
  const hasMounted = useHasMounted();
  const breakpoint = useBreakpoint();
  if (!hasMounted || on !== 'client' && (typeof on === 'object' ? !on.find(v => breakpoint[breakpointMap[v]]) : !breakpoint[breakpointMap[on]])) return null;
  return /*#__PURE__*/jsx(Fragment, {
    children: children
  });
}
export { Only };
//# sourceMappingURL=Only.js.map
